import React, {useState, useEffect, useContext} from 'react';
import isEmpty from 'lodash/isEmpty';
import LocalStorage from 'utils/localStorage';
import {getCountries} from 'api/common';
import {DATA_COUNTRY_VERSION, COUNTRY_VERSION} from 'configs';
import {countryArrayParserToObject} from 'utils/locales';
import {LoadingPage} from 'components/Loading';

const CommonDataContext = React.createContext({});
const CommonDataConsumer = CommonDataContext.Consumer;

function CommonDataProvider({children}) {
  const {countries: countriesStorage} = LocalStorage;
  const {data: countriesData, dataVersion, countryVersion} = countriesStorage;

  const [isLoading, setIsLoading] = useState(true);
  const [countriesState, setCountriesState] = useState({
    data: countriesData || [],
    dataVersion: dataVersion || null,
    countryVersion: countryVersion || null,
  });

  useEffect(() => {
    const {data, dataVersion, countryVersion} = countriesStorage;

    if (
      isEmpty(data) ||
      dataVersion !== DATA_COUNTRY_VERSION ||
      countryVersion !== COUNTRY_VERSION
    ) {
      fetch();
    } else {
      setIsLoading(false);
    }
  }, [countriesStorage]);

  const fetch = async () => {
    setIsLoading(true);
    const {data} = await getCountries();

    const result = {
      data,
      dataVersion: DATA_COUNTRY_VERSION,
      countryVersion: COUNTRY_VERSION,
    };

    LocalStorage.countries = result;
    setCountriesState(result);
    setIsLoading(false);
  };

  const countries = countryArrayParserToObject(
    countriesState.data,
    countriesState.countryVersion
  );

  return (
    <CommonDataContext.Provider value={{countries}}>
      {isLoading && <LoadingPage />}
      {!isLoading && children}
    </CommonDataContext.Provider>
  );
}

const useCommonData = () => useContext(CommonDataContext);

export {CommonDataProvider, CommonDataConsumer, useCommonData};
